// tslint:disable
// this is an auto generated file. This will be overwritten

export const createPrivateWebSetting = `mutation CreatePrivateWebSetting(
  $input: CreatePrivateWebSettingInput!
  $condition: ModelPrivateWebSettingConditionInput
) {
  createPrivateWebSetting(input: $input, condition: $condition) {
    id
    accept_email
    owner
    _version
    _deleted
    _lastChangedAt
  }
}
`;
export const updatePrivateWebSetting = `mutation UpdatePrivateWebSetting(
  $input: UpdatePrivateWebSettingInput!
  $condition: ModelPrivateWebSettingConditionInput
) {
  updatePrivateWebSetting(input: $input, condition: $condition) {
    id
    accept_email
    owner
    _version
    _deleted
    _lastChangedAt
  }
}
`;
export const deletePrivateWebSetting = `mutation DeletePrivateWebSetting(
  $input: DeletePrivateWebSettingInput!
  $condition: ModelPrivateWebSettingConditionInput
) {
  deletePrivateWebSetting(input: $input, condition: $condition) {
    id
    accept_email
    owner
    _version
    _deleted
    _lastChangedAt
  }
}
`;
export const createPrivateEnquete = `mutation CreatePrivateEnquete(
  $input: CreatePrivateEnqueteInput!
  $condition: ModelPrivateEnqueteConditionInput
) {
  createPrivateEnquete(input: $input, condition: $condition) {
    id
    enquete1
    owner
    _version
    _deleted
    _lastChangedAt
  }
}
`;
export const updatePrivateEnquete = `mutation UpdatePrivateEnquete(
  $input: UpdatePrivateEnqueteInput!
  $condition: ModelPrivateEnqueteConditionInput
) {
  updatePrivateEnquete(input: $input, condition: $condition) {
    id
    enquete1
    owner
    _version
    _deleted
    _lastChangedAt
  }
}
`;
export const deletePrivateEnquete = `mutation DeletePrivateEnquete(
  $input: DeletePrivateEnqueteInput!
  $condition: ModelPrivateEnqueteConditionInput
) {
  deletePrivateEnquete(input: $input, condition: $condition) {
    id
    enquete1
    owner
    _version
    _deleted
    _lastChangedAt
  }
}
`;
